import { Popover } from 'antd';

export const IsoPopover = Popover;
